import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getHomePorRol } from "../utils/rolUtils";

const ProtectedRoute = ({ redirectTo = "/login", allowedRoles = [] }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to={redirectTo} replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const userRole = decoded["rol"];

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to={getHomePorRol(userRole)} replace />;
    }

    return <Outlet />;
  } catch (error) {
    console.error("Error decoding token:", error);
    localStorage.removeItem("token");
    return <Navigate to={redirectTo} replace />;
  }
};

export default ProtectedRoute;